import { render } from "./TwoFactorWarning.vue?vue&type=template&id=6e7c3592"
import script from "./TwoFactorWarning.vue?vue&type=script&lang=js"
export * from "./TwoFactorWarning.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__